import urlcat from 'urlcat';

import { Routes } from 'src/constants/routes';

import { SearchParamKnownKeys } from 'src/hooks/useUrlSearchParams';

export enum AccountSettingsTab {
  API_KEYS = 'api-keys',
  CONNECTED_APPS = 'connected-apps',
  GENERAL = 'general',
  APPS = 'apps',
  NOTIFICATIONS = 'notifications',
  APPEARANCE = 'appearance',
}

export type AccountSettingsUrlType = `/account/settings/${AccountSettingsTab}`;

type Props = {
  tab: AccountSettingsTab;
  returnTo?: string;
};

export const getAccountSettingUrls = ({ tab, returnTo }: Props): AccountSettingsUrlType => {
  return urlcat('', Routes.AccountSettings, {
    tab,
    [SearchParamKnownKeys.RETURN_TO]: returnTo,
  }) as AccountSettingsUrlType;
};
